import { ErrorModal } from "./ErrorModal";

interface JoinErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage?: string;
}

export function JoinErrorModal({
  isOpen,
  onClose,
  errorMessage,
}: JoinErrorModalProps) {
  return (
    <ErrorModal
      isOpen={isOpen}
      onClose={onClose}
      title="Join Failed"
      message={errorMessage || "Your join challenge attempt failed. Please try again."}
      variant="error"
      actionLabel="Try Again"
    />
  );
}
